import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  Row,
  Col,
} from "reactstrap";
import faqModel from "models/faq.model";
import { helper } from "lib/helper";
import Loader from "components/loader/Loader";
import City from ".";
import statesModel from "models/states.model";

const EditState = () => {
  const [addsLoadig, setAddsLoadig] = useState(false);
  const [dataList, setDataList] = useState(null);
  const navigate = useNavigate();
  const parmas = useParams();
  const id = parmas?.id

  const handleSubmitEditState = (event) => {
    setAddsLoadig(true);
    event.preventDefault();
    const form = new FormData(event.target);

    // You can adjust the header configuration according to your API requirements
    statesModel
      .updateCity(id,form)
      .then((response) => {
        helper.sweetalert.toast("Your City Edit.", "success");
        navigate("/admin/city");
        setAddsLoadig(false);
        // Display success message to the user
      })
      .catch((error) => {
        setAddsLoadig(false);
        // console.log(error);
      });
  };

  const getListDataByidCity = () => {
    statesModel
      .detailCity(parmas?.id)
      .then((response) => {
        setDataList(response.data);
      })
      .catch((error) => {
        // console.log(error);
      });
  };
  useEffect(() => {
    if (parmas.id != "") {
      getListDataByidCity();
    }
  }, []);

  return (
    <>
      <Container className="pt-7">
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between ">
                <h3 className="mb-0">Edit State</h3>
              </CardHeader>

              <CardBody>
                <div>
                  <Form onSubmit={handleSubmitEditState}>
                    <Row>
                      <Col md={12}>
                        <FormGroup>
                          <Label for="exampleEmail">State Name</Label>
                          <Input
                            style={{
                              border: "1px solid lightgrey",
                              padding: "6px 10px",
                              borderRadius: "6px",
                            }}
                            id="name"
                            name="name"
                            placeholder="Enter State Name"
                            defaultValue={dataList && dataList.name}
                          />
                        </FormGroup>
                      </Col>

                    </Row>

                   

                    {/* <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Added Date</Label>
                    <Input id="contact" name="contact" type="number" />
                  </FormGroup>
                </Col>

                <Col md={6}>
                  <FormGroup>
                    <Label for="exampleEmail">Status</Label>
                    <Input id="status" name="status" type="select">
                      <option value="">Activate</option>
                      <option value="option1">Deactivate</option>
                      <option value="option2">Pending</option>
                    </Input>
                  </FormGroup>
                </Col>
              </Row> */}

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Button color="secondary" to="/admin/state" tag={Link}>
                        Cancel
                      </Button>

                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : (
                        <Button
                         
                          type="submit"
                          style={{ float: "right", marginLeft: "5%" ,backgroundColor:"#080278",color:"white",border:"none"}}
                        >
                          Save
                        </Button>
                      )}
                    </div>
                  </Form>
                </div>
              </CardBody>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};




export default EditState